import * as React from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import { Divider } from '@mui/material';
import Person2RoundedIcon from '@mui/icons-material/Person2Rounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import './Instructors.css';

const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 22,
    height: 22,
    border: `2px solid ${theme.palette.background.paper}`,
}));

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

export default function InstructorsComponent(props) {
    const { isSmallScreen, name, url, setClicked, clicked, content } = props;

    return (
        <div className="card example-2" style={{ width: isSmallScreen ? "90%" : "80%", marginLeft: isSmallScreen ? "0px" : "10%", marginBottom: "35px", cursor: "pointer", border: "2px solid rgba(0,0,0,0.00)", borderRadius: "10px", margin: isSmallScreen && "1rem" }}>
            <div className="inner">
                <div style={{ width: "100%", display: "flex", marginTop: "15px", height:"50px" }}>
                    <div style={{ margin: "auto" }}>
                        <Avatar alt="Remy Sharp" src={url} style={{ height: "4rem", width: "4rem" }} />
                    </div>
                    <div style={{ width: "60%", margin: "auto" }}>
                        <div style={{ fontWeight: "500" }}>{name}</div>
                    </div>
                </div>
                <Divider style={{ margin: "20px 30% 20px 30%", backgroundColor: "#0075c9" }} />
                <div style={{ textAlign: "left", color: "#666666", padding: isSmallScreen ? "0 5% 0 5%" : "0 10px 10px 10px", display: "flex" }}>
                    <div>
                        <Person2RoundedIcon />
                    </div>
                    <div> Microsoft Certified Trainer</div>
                </div>
                <div style={{ textAlign: "left", color: "#666666", padding: isSmallScreen ? "0 5% 0 5%" : "0 10px 10px 10px", display: "flex" }}>
                    <div>
                        <StarRoundedIcon />
                    </div>
                    <div> {
                        clicked
                            ?
                            <div style={{ textAlign: "left", color: "#666666", padding: isSmallScreen && "0 5% 0 5%" }}>
                                {content}
                            </div>
                            :
                            <div style={{ textAlign: "left", color: "#666666", padding: isSmallScreen && "0 5% 0 5%" }}>
                                {content.substring(0, 130) + "..."}
                            </div>
                    }</div>
                </div>
                <div style={{ textAlign: "center", color: "blue", paddingBottom: "10px" }} onClick={(e) => setClicked(!clicked)}>{
                    clicked ?
                        "Read Less"
                        :
                        "Read More"
                }</div>
            </div>
        </div>
    );
}